import axios from "axios";
import { base_url, httpHeaderConfig } from "../shared/const.prop";

const axiosHttp = axios.create({
  baseURL: base_url,
});

axiosHttp.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    return {
      ...config,
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...config.headers,
        ...httpHeaderConfig,
      },
    };
  },
  (error) => {
    throw new Error(error?.response?.data?.message || "Error");
  }
);

axiosHttp.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url;
    
    // Check if we're handling a Google account update callback
    // Check both URL parameters and sessionStorage flag (more reliable)
    const isGoogleCallback = window.location.search.includes("google=connected") || 
                            sessionStorage.getItem('google_account_update_in_progress') === 'true';
    
    if (error.response?.status === 401 && requestUrl !== "login") {
      // Don't redirect if we're in the middle of a Google account update
      // This prevents logout when user changes Google account
      if (!isGoogleCallback && requestUrl !== "profile") {
        window.location.href = "/login";
      } else {
        // For profile endpoint during Google callback, allow the error to be handled by the component
        // Don't redirect to login - let the component handle the error gracefully
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }
);

export default axiosHttp;
